export default {
    state: () => ({
        formHasError: false,
        submitNextClick: 0,
        expenditureRequest: {
            type: 'allotment_request',
            expenditure_id: 4,
            contractor_id: '',
            amount: 0,
            purpose: '',
            images: [],
            target_pet_id: '',
            target_project_id: ''
        }
    }),

    getters: {
        getterExpenditureRequest(state) {
            return state.expenditureRequest
        },
        getterSubmitNextClick(state) {
            return state.submitNextClick;
        },
        getterFormHasError(state) {
            return state.formHasError;
        }
    },

    mutations: {
        setterExpenditureRequest(state, data) {
            state.expenditureRequest = data
        },
        setterExpenditureRequestParam(state, {key, data}) {
            state.expenditureRequest[key] = data
        },
        pushImage(state, file) {
            state.expenditureRequest.images.push(file)
        },
        deleteImageByIndex(state, index){
            state.expenditureRequest.images.splice(index, 1)
        },
        resetTarget(state) {
            state.expenditureRequest.target_pet_id = '';
            state.expenditureRequest.target_project_id = '';
        },
        setterSubmitNextClick(state) {
            state.submitNextClick = Date.now();
        },
        setterFormHasError(state, data) {
            state.formHasError = data;
        },
        resetState(state) {
            state.expenditureRequest.expenditure_id = 4;
            state.expenditureRequest.contractor_id = '';
            state.expenditureRequest.amount = 0;
            state.expenditureRequest.purpose = '';
            state.expenditureRequest.images = [];
            state.expenditureRequest.target_pet_id = '';
            state.expenditureRequest.target_project_id = '';

            state.formHasError = false;
        }
    },
}
